import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { reactIcons } from "../../../utils/icons";
import "react-datepicker/dist/react-datepicker.css";
import CustomSelect from "../../Common/CustomSelect";
import { Countriess } from "../../constants/contries";
import CustomDatePicker from "../../Common/CustomDatePicker";
const EntityFormlog = ({
  handleChange,
  formError,
  handleCountryChange,
  selectedCountry,
  Country,
  dialCode,
  onStepComplete,
  form,
  isReadOnly
}) => {
  const [startDate, setStartDate] = useState(
    form?.dateOfIncorporation ? new Date(form.dateOfIncorporation) : null
  );

  const initialValues = {
    type: "LogisticsProvider",
    primaryContactName: form?.primaryContactName || "",
    name: form?.name || "",
    RegistrationNumber: form?.registrationNumber || "",
    emailAddress: form?.emailAddress || "",
    phoneNumber: form?.phoneNumber?.replace(/^\+?91/, "") || "",
    website: form?.website || "",
    address: form?.address || "",
    dateOfIncorporation: form?.dateOfIncorporation
      ? new Date(form.dateOfIncorporation)
      : null,
    countryOfIncorporation: form?.countryOfIncorporation.toLowerCase() || ""
  };

  useEffect(() => {
    if (form?.dateOfIncorporation) {
      setStartDate(new Date(form.dateOfIncorporation));
    }
  }, [form?.dateOfIncorporation]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={Yup.object({
        type: Yup.string().required("Business Type is required"),

        primaryContactName: Yup.string()
          .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed")
          .min(2, "Minimum 2 characters")
          .max(50, "Maximum 100 characters allowed")
          .required("Primary Contact Name is required"),

        name: Yup.string()
          .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed")
          .min(2, "Minimum 2 characters")
          .max(50, "Maximum 50 characters allowed")
          .required("Entity Name is required"),

        RegistrationNumber: Yup.string()
          .trim()
          .min(3, "Registration Number must be at least 3 characters")
          .required("Registration Number is required"),

        emailAddress: Yup.string()
          .email("Invalid email format")
          .required("Email Address is required"),

        phoneNumber: Yup.string()
          .matches(/^[0-9]+$/, "Only numbers are allowed")
          .min(8, "Phone Number too short")
          .max(15, "Phone Number too long")
          .required("Mobile Number is required"),

        // website: Yup.string()
        //   .url("Must be a valid URL")
        //   .nullable()
        //   .notRequired(),

        address: Yup.string()
          .trim()
          .min(5, "Address must be at least 5 characters")
          .required("Physical Address is required"),

        dateOfIncorporation: Yup.date()
          .nullable()
          .typeError("Invalid date format")
          .required("Date of Incorporation is required")
          .max(new Date(), "Date can’t be in the future"),

        countryOfIncorporation: Yup.string().required(
          "Country of Incorporation is required"
        )
      })}
      onSubmit={(values, { setTouched }) => {
        onStepComplete(values);
      }}
    >
      {({
        setFieldValue,
        setTouched,
        handleSubmit,
        errors,
        touched,
        values
      }) => (
        <>
          <Form className="lg:grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-black">Business Type</label>
              <div className="relative">
                <Field
                  as="input"
                  type="text"
                  name="type"
                  value="LogisticsProvider"
                  readOnly
                  className="bg-white text-12 lg:text-14 text-black"
                />
              </div>
              <ErrorMessage name="type" component="div" className="form-eror" />
            </div>

            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                Primary Contact Name<span className="text-red-600">*</span>
              </label>
              <Field
                type="text"
                placeholder="Enter Primary Contact Name "
                name="primaryContactName"
                // className="text-input text-black text-12 lg:text-14 border"
                readOnly={isReadOnly}
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                maxLength={50}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab"
                  ];
                  if (
                    !/^[a-zA-Z\s]$/.test(e.key) &&
                    !allowedKeys.includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              <ErrorMessage
                name="primaryContactName"
                component="div"
                className="form-eror"
              />
            </div>

            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                Entity Name<span className="text-red-600">*</span>
              </label>
              <Field
                type="text"
                placeholder="Enter Entity Name "
                name="name"
                // className="text-input text-black text-12 lg:text-14 border"
                readOnly={isReadOnly}
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                maxLength={100}
                autoComplete="off"
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab"
                  ];
                  if (
                    !/^[a-zA-Z\s]$/.test(e.key) &&
                    !allowedKeys.includes(e.key)
                  ) {
                    e.preventDefault();
                  }
                }}
              />
              <ErrorMessage name="name" component="div" className="form-eror" />
            </div>

            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                Registration Number<span className="text-red-600">*</span>
              </label>
              <Field
                type="text"
                placeholder="Enter Registration Number"
                name="RegistrationNumber"
                // className="text-input text-black border-[#BEBEBE] text-12 lg:text-14 border"
                readOnly={isReadOnly}
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
              />
              <ErrorMessage
                name="RegistrationNumber"
                component="div"
                className="form-eror"
              />
            </div>
            <div className="mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                Country of Incorporation <span className="text-red-600">*</span>
              </label>
              <CustomSelect
                name="countryOfIncorporation"
                options={Countriess.map((item) => ({
                  value: item.value,
                  label: item.title
                }))}
                placeholder="Select Country"
                onChange={(e) =>
                  setFieldValue("countryOfIncorporation", e.target.value)
                }
                value={values.countryOfIncorporation}
                disabled={isReadOnly}
                className="mb-3"
                dropdownClassName="border-mustard"
                optionClassName="hover:!bg-mustard"
                selectedOptionClassName="!bg-mustard"
              />

              {touched.countryOfIncorporation &&
                errors.countryOfIncorporation && (
                  <div className="form-eror">
                    {errors.countryOfIncorporation}
                  </div>
                )}
            </div>

            <div className="input_ mb-3 lg:mb-0">
              <label className="mb-2 block text-black relative">
                Date of Incorporation<span className="text-red-600">*</span>
              </label>
              <CustomDatePicker
                selectedDate={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  setFieldValue("dateOfIncorporation", date);
                }}
                placeholder="dd-mm-yyyy"
                disableFuture={true}
                readOnly={isReadOnly}
                touched={touched.dateOfIncorporation}
                // error={errors.dateOfIncorporation}
              />

              <ErrorMessage
                name="dateOfIncorporation"
                component="div"
                className="form-eror"
              />
            </div>

            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-black">Website</label>
              <Field
                type="text"
                placeholder="Enter  Website"
                name="website"
                // className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                readOnly={isReadOnly}
              />
              <ErrorMessage
                name="website"
                component="div"
                className="form-eror"
              />
            </div>

            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                Email Address<span className="text-red-600">*</span>
              </label>
              <Field
                type="text"
                placeholder="Enter  Email Address"
                name="emailAddress"
                // className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("emailAddress", e.target.value);
                }}
                value={values.emailAddress}
                readOnly={isReadOnly}
              />
              <ErrorMessage
                name="emailAddress"
                component="div"
                className="form-eror"
              />
            </div>

            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                Mobile Number<span className="text-red-600">*</span>
              </label>
              <div className="relative">
                <span className="absolute left-[1px] top-[2px] py-[16.4px] lg:py-[11.4px] px-[6px] border border-r-black border-y-0 border-l-0 min-w-[50px] h-[45px] flex items-center justify-center">
                  +{dialCode}
                </span>
                <Field
                  type="number"
                  placeholder="Enter  Phone Number"
                  name="phoneNumber"
                  className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14 pl-[60px]"
                  // className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                  readOnly={isReadOnly}
                />
                <ErrorMessage
                  name="phoneNumber"
                  component="div"
                  className="form-eror"
                />
              </div>
            </div>

            <div className="input_field mb-3 lg:mb-0">
              <label className="mb-2 block text-black">
                {" "}
                Address<span className="text-red-600">*</span>
              </label>
              <Field
                as="textarea"
                name="address"
                // className="text-input text-black border border-[#BEBEBE] text-12 lg:text-14"
                className={`text-input ${isReadOnly ? "readonly-input" : ""}`}
                placeholder="Enter  Address"
                rows={6}
                // maxLength={100}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue("address", e.target.value);
                }}
                value={values.address}
                readOnly={isReadOnly}
              />
              <ErrorMessage
                name="address"
                component="div"
                className="form-eror"
              />
            </div>
          </Form>

          <div className="flex gap-2 mt-5 justify-end items-center">
            <button
              type="button"
              onClick={() => {
                setTouched({
                  primaryContactName: true,
                  name: true,
                  RegistrationNumber: true,
                  email: true,
                  phoneNumber: true,
                  website: true,
                  address: true,
                  dateOfIncorporation: true
                });
                handleSubmit();
              }}
              className={`btn btn-primary`}
            >
              Next {reactIcons.arrowright}
            </button>
          </div>
        </>
      )}
    </Formik>
  );
};

export default EntityFormlog;
